import { SidebarConfig, UnifiedMenuItem } from "./UnifiedSidebar";

// Helper function to create a sidebar configuration
export const createSidebarConfig = (
  logo: string,
  logoAlt: string,
  menuItems: UnifiedMenuItem[],
  options?: {
    moduleName?: string;
    defaultWidth?: number;
    collapsedWidth?: number;
    autoExpandPaths?: { [menuId: string]: string };
  }
): SidebarConfig => {
  return {
    logo,
    logoAlt,
    moduleName: options?.moduleName,
    defaultWidth: options?.defaultWidth || 280,
    collapsedWidth: options?.collapsedWidth || 72,
    menuItems,
    autoExpandPaths: options?.autoExpandPaths,
  };
};

// Helper function to create a menu item
export const createMenuItem = (
  id: string,
  text: string,
  path: string,
  options?: {
    icon?: string;
    permission?: string;
    requiresModuleAdmin?: boolean;
    subItems?: UnifiedMenuItem[];
  }
): UnifiedMenuItem => {
  return {
    id,
    text,
    path,
    icon: options?.icon,
    permission: options?.permission,
    requiresModuleAdmin: options?.requiresModuleAdmin,
    subItems: options?.subItems,
  };
};

// Helper function to create a menu item that requires module admin access
export const createModuleAdminMenuItem = (
  id: string,
  text: string,
  path: string,
  options?: {
    icon?: string;
    subItems?: UnifiedMenuItem[];
  }
): UnifiedMenuItem => {
  return createMenuItem(id, text, path, {
    ...options,
    requiresModuleAdmin: true,
  });
};

// Helper function to create a menu item with permission
export const createPermissionMenuItem = (
  id: string,
  text: string,
  path: string,
  permission: string,
  options?: {
    icon?: string;
    subItems?: UnifiedMenuItem[];
  }
): UnifiedMenuItem => {
  return createMenuItem(id, text, path, {
    ...options,
    permission,
  });
};

// Helper function to create a submenu item
export const createSubMenuItem = (
  id: string,
  text: string,
  path: string,
  options?: {
    icon?: string;
    permission?: string;
    requiresModuleAdmin?: boolean;
  }
): UnifiedMenuItem => {
  return createMenuItem(id, text, path, options);
};

// Common auto-expand configurations
export const createAutoExpandConfig = (
  configs: Array<{
    menuId: string;
    pathPrefix: string;
  }>
): { [menuId: string]: string } => {
  const result: { [menuId: string]: string } = {};
  configs.forEach(({ menuId, pathPrefix }) => {
    result[menuId] = pathPrefix;
  });
  return result;
};
